import React from "react";
import { Collapse, Grid, Typography, Box } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import StoreIcon from "@mui/icons-material/Store";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const OrderDetails = ({ expanded, fulfillment, customer, payment, meta }) => {
  const renderFulfillmentIcon = () =>
    fulfillment.method === "delivery" ? (
      <LocalShippingIcon fontSize="small" />
    ) : (
      <StoreIcon fontSize="small" />
    );

  return (
    <Collapse in={expanded}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography fontWeight={600} gutterBottom>
            Fulfillment
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            {renderFulfillmentIcon()}
            <Typography variant="body2">{fulfillment.method}</Typography>
          </Box>
          <Typography variant="body2">
            {dayjs(fulfillment.date)
              .tz("America/St_Johns")
              .format("MMM D, YYYY")}{" "}
            • {fulfillment.time}
            {/* {dayjs(fulfillment.date).format("MMM D, YYYY")} • {fulfillment.time} */}
          </Typography>
          {fulfillment.location && (
            <Typography variant="body2">{fulfillment.location}</Typography>
          )}
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography fontWeight={600} gutterBottom>
            Customer
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            <PersonIcon fontSize="small" />
            <Typography variant="body2">
              {customer.firstName} {customer.lastName}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <EmailIcon fontSize="small" />
            <Typography variant="body2">{customer.email}</Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            <PhoneIcon fontSize="small" />
            <Typography variant="body2">{customer.phone}</Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Typography fontWeight={600} gutterBottom>
            Payment Info
          </Typography>
          <Typography variant="body2">
            Status: {payment.paid ? "Paid" : "Unpaid"}
          </Typography>
          <Typography variant="body2">
            Method: {payment.paymentMethod?.type || "N/A"}
            {payment.paymentMethod?.brand &&
              ` • ${payment.paymentMethod.brand.toUpperCase()}`}
            {payment.paymentMethod?.last4 &&
              ` •••• ${payment.paymentMethod.last4}`}
          </Typography>
          {payment.receiptNumber && (
            <Typography variant="body2">
              Receipt #: {payment.receiptNumber}
            </Typography>
          )}
        </Grid>

        <Grid item xs={12} md={6}>
          {meta.notes && (
            <>
              <Typography fontWeight={600} gutterBottom>
                Notes
              </Typography>
              <Typography variant="body2">{meta.notes}</Typography>
            </>
          )}
          {meta.coupon && (
            <>
              <Typography fontWeight={600} gutterBottom>
                Coupon
              </Typography>
              <Typography variant="body2">
                {meta.coupon.code} - {meta.coupon.discount} OFF
              </Typography>
            </>
          )}
        </Grid>
      </Grid>
    </Collapse>
  );
};

export default OrderDetails;
